import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

// allowedRoles: izin verilen roller dizisi örn: ['admin', 'user']
// redirectTo: izin yoksa yönlendirilecek sayfa
const ProtectedRoute = ({ children, allowedRoles = [], redirectTo = '/forbidden' }) => {
  const navigate = useNavigate();
  
  useEffect(() => {
    // Token kontrol et
    const token = localStorage.getItem('authToken');
    if (!token) {
      // Token yoksa login sayfasına yönlendir
      navigate('/login');
      return;
    }
    
    try {
      // Token'dan rol bilgisini çıkar
      const payload = token.split('.')[1];
      const decodedPayload = JSON.parse(atob(payload));

      // Token süresi kontrolü (exp claim)
      const currentTime = Math.floor(Date.now() / 1000); // saniye cinsinden mevcut zaman
      if (decodedPayload.exp && decodedPayload.exp < currentTime) {
        // Token süresi dolmuş, tokenı temizle ve login'e yönlendir
        localStorage.removeItem('authToken');
        navigate('/login');
        return;
      }

      const userRole = decodedPayload.data?.role;
      
      // Rol izin kontrolü
      if (allowedRoles.length > 0 && !allowedRoles.includes(userRole)) {
        // Kullanıcının rolü izin verilen roller arasında yoksa yönlendir
        navigate(redirectTo);
      }
    } catch (error) {
      console.error('Token çözümleme hatası:', error);
      navigate('/login');
    }
  }, [navigate, allowedRoles, redirectTo]);
  
  return <>{children}</>;
};

export default ProtectedRoute; 